var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"green--text",attrs:{"width":"40","height":"40","elevation":"0","fab":"","rounded":"","depressed":"","ripple":false},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',[_vm._v("fa-light fa-chevron-left")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }